import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../components/login.vue'),
      meta:{
        label:'登录'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/login.vue'),
      meta:{
        label:'登录'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../components/Home.vue'),
      meta:{
        label:'首页'
      }
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('../components/ticket.vue'),
      meta:{
        label:'门票预订'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('../components/order.vue'),
      meta:{
        label:'订单列表'
      }
    },
    {
      path: '/orderReport',
      name: 'orderReport',
      component: () => import('../components/orderReport.vue'),
      meta:{
        label:'订单报表'
      }
    },
    {
      path: '/repayment',
      name: 'repayment',
      component: () => import('../components/repayment.vue'),
      meta:{
        label:'授信还款管理'
      }
    },
    {
      path: '/creditDetails',
      name: 'creditDetails',
      component: () => import('../components/creditDetails.vue'),
      meta:{
        label:'授信变动明细'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js